import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Switch, Button, message } from 'antd';
import { ISpecialty } from 'types/operation';
import s from './s.module.less';
import { updateKlaritySpecialtyInHP } from 'api/operation';

interface IProps {
    open: boolean;
    pageId: string;
    specialty?: ISpecialty;
    onSuccess: () => void;
    onCancel: () => void;
}

const EditSpecialtyModal: React.FC<IProps> = ({ open, pageId, specialty, onSuccess, onCancel }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (specialty) {
            form.setFieldsValue({
                specialtyName: specialty.specialtyName,
                status: specialty.status === 'A',
            });
        }
    }, [specialty, form]);

    const handleCancel = () => {
        form.resetFields();
        onCancel?.();
    };

    const handleOk = () => {
        if (!pageId) {
            message.error('Page ID is required');
            return;
        }

        form.validateFields().then(async (values) => {
            try {
                setLoading(true);
                const res = await updateKlaritySpecialtyInHP({
                    id: specialty?.id,
                    pageId: Number(pageId),
                    specialtyName: values.specialtyName,
                    status: values.status ? 'A' : 'D',
                    specialtyPriority: specialty?.specialtyPriority || null,
                });

                if (res && !res.error) {
                    onSuccess?.();
                    form.resetFields();
                } else {
                    message.error(res.message);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        });
    };

    return (
        <Modal
            open={open}
            title={<div className={s.modalTitle}>{specialty ? `Edit ${specialty.specialtyName}` : 'Add Specialty'}</div>}
            onCancel={handleCancel}
            onOk={handleOk}
            okText="Save changes"
            confirmLoading={loading}
            destroyOnClose
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    label={<div className={s.switchRow}><span>Status</span><span style={{ color: 'red' }}>*</span></div>}
                    name="status"
                    valuePropName="checked"
                    className={s.formItem}
                >
                    <Switch
                        checkedChildren="Active"
                        unCheckedChildren="Inactive"
                        style={{ width: 80 }}
                    />
                </Form.Item>
                <Form.Item
                    label={<span>Specialty name <span style={{ color: 'red' }}>*</span></span>}
                    name="specialtyName"
                    className={s.formItem}
                    rules={[
                        { required: true, message: 'Please input the specialty name' },
                        { max: 30, message: 'Max 30 characters' },
                    ]}
                >
                    <Input className={s.input} maxLength={30} showCount />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default EditSpecialtyModal;
